import { AxiosGetRequestOptions, AxiosPostRequestOptions } from '@/package';
import type { TenantApi } from '@/type';
import { apiOf } from '@/util';

export const changePassword = apiOf<
  TenantApi.ChangePassword.Request,
  TenantApi.ChangePassword.Response
>(
  new AxiosPostRequestOptions({
    url: '/v1/miri/tenant/change-password',
  }),
);
export const getUsage = apiOf<
  TenantApi.GetUsage.Request,
  TenantApi.GetUsage.Response
>(new AxiosGetRequestOptions({ url: '/v1/miri/tenant/usage' }));

export const getTenantInfo = apiOf<
  TenantApi.GetTenantInfo.Request,
  TenantApi.GetTenantInfo.Response
>(
  new AxiosGetRequestOptions({
    url: '/v1/miri/tenant/info',
  }),
);

export const inviteUser = apiOf<
  TenantApi.InviteUser.Request,
  TenantApi.InviteUser.Response
>(new AxiosPostRequestOptions({ url: '/v1/miri/tenant/invite' }));

export const updatePlan = apiOf<
  TenantApi.UpdatePlan.Request,
  TenantApi.UpdatePlan.Response
>(new AxiosPostRequestOptions({ url: '/v1/miri/tenant/plan' }));
